//Dependencies
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
//Main Components
import Drawer from '../../../components/Drawer';
//Components

const Drawer04 = (props) =>
{
  const { isMobile } = props; 
  const dispatch = useDispatch();

  const drawer03 = useSelector(state => state.drawers.drawer04);

  const construction = useSelector(state => state.portfolio.construction);
  const design = useSelector(state => state.portfolio.design);
  const images = useSelector(state => state.portfolio.images);

  const closeDrawer = () =>
  {
    const scroller = document.querySelector("#scroller");
    scroller.scrollTo(0,0);

    dispatch({type: 'SET_DRAWER_04', drawer04 : false});
  };


  return(
    <Drawer
      height    = {isMobile ? 80 : 60}
      visible   = {drawer03}
      onClose   = {() => closeDrawer()}      
    >
      <div className = "w-full bg-white select-none">
        <p className = "flex mt-10 justify-center text-base md:text-2xl lg:text-4xl font-semibold font-mono uppercase">
          CONSTRUCCIÓN
        </p>

        <div className = "flex bg-white">
          <div className = "w-full justify-center flex">
            <div className = {`px-5 grid grid-cols-2 lg:grid-cols-3 gap-1 ${construction && Object.keys(construction).length > 2 ? 'lg:grid-cols-3' : construction && Object.keys(construction).length > 1 ? 'lg:grid-cols-2' : 'lg:grid-cols-1'}`}>
              {construction}
            </div>
          </div>
        </div>

        <p className = "flex mt-10 justify-center text-base md:text-2xl lg:text-4xl font-semibold font-mono uppercase">
          DISEÑO
        </p>

        <div className = "flex bg-white">
          <div className = "w-full justify-center flex">
            <div className = {`px-5 grid grid-cols-2 lg:grid-cols-3 gap-1 ${design && Object.keys(design).length > 2 ? 'lg:grid-cols-3' : design && Object.keys(design).length > 1 ? 'lg:grid-cols-2' : 'lg:grid-cols-1'}`}>
              {design}
            </div>
          </div>
        </div>

        <p className = "flex mt-10 justify-center text-base md:text-2xl lg:text-4xl font-semibold font-mono uppercase">
          IMÁGENES
        </p>

        <div className = "flex bg-white">
          <div className = "w-full justify-center flex">
            <div className = {`px-5 grid grid-cols-2 lg:grid-cols-3 gap-1 ${images && Object.keys(images).length > 2 ? 'lg:grid-cols-3' : images && Object.keys(images).length > 1 ? 'lg:grid-cols-2' : 'lg:grid-cols-1'}`}>
              {images}
            </div>
          </div>
        </div>

        <div className = "flex justify-center bg-white"  >
          <button
              className = 'bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 border border-red-700 rounded lg:w-1/4 w-2/3 text-lg tracking-widest mb-2 mt-5'
              onClick={() => 
                {
                  closeDrawer();
                }}
            >
              CERRAR
            </button>
        </div>
      </div>
    </Drawer>
  );
}

export default Drawer04;